import { rollDiceWithBox } from '../../../utils/diceBoxManager';
import { notify } from '../../../utils/notification';

const isHalfling = (character) => {
  const race = character?.race;
  return String(typeof race === 'string' ? race : race?.name || race?.Name || '').trim().toLowerCase() === 'halfling';
};

const rerollD20s = async (count) => {
  try {
    const values = (await rollDiceWithBox([{ count, sides: 20 }]))?.rolls?.[0];
    const dice = (Array.isArray(values) ? values : [values]).map(Number).filter((value) => Number.isInteger(value) && value >= 1 && value <= 20);
    if (dice.length === count) return dice;
  } catch { /* Fall back to a plain roll below. */ }
  return Array.from({ length: count }, () => Math.floor(Math.random() * 20) + 1);
};

/**
 * 2024 Halfling Luck: when a Halfling rolls a 1 on the d20 of a D20 Test (attack roll, ability check or saving throw,
 * death saves included), it rerolls the die and must use the new roll. Rerolls every d20 showing 1 (with Advantage or
 * Disadvantage either one may be the kept die) and returns the dice to use, with the original faces when it applied.
 */
export async function withHalflingLuck(character, d20s, { reroll = rerollD20s, label = 'd20' } = {}) {
  const dice = Array.isArray(d20s) ? d20s : [];
  const ones = dice.filter((value) => Number(value) === 1).length;
  if (!isHalfling(character) || !ones) return { d20s: dice, halflingLuck: null };
  const fresh = await reroll(ones);
  let next = 0;
  const rerolled = dice.map((value) => (Number(value) === 1 ? fresh[next++] : value));
  notify(`Halfling Luck · Rerolled a 1 on the ${label}: ${fresh.join(', ')}.`, 'info');
  return { d20s: rerolled, halflingLuck: { from: dice, to: rerolled } };
}
